import { render, staticRenderFns } from "./DragAndDropSidebarLogo.vue?vue&type=template&id=7da5c2b2&scoped=true"
import script from "./DragAndDropSidebarLogo.vue?vue&type=script&lang=js"
export * from "./DragAndDropSidebarLogo.vue?vue&type=script&lang=js"
import style0 from "./DragAndDropSidebarLogo.vue?vue&type=style&index=0&id=7da5c2b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da5c2b2",
  null
  
)

export default component.exports